import {
  SUBSCRIPTION_ACCOUNT_PREMIER,
  SUBSCRIPTION_ACCOUNT_CUSTOM_STATIONS,
  SUBSCRIPTION_ACCOUNT_PRIME,
  SUBSCRIPTION_ACCOUNT_PRIME_ADS_FREE,
  SUBSCRIPTION_ACCOUNT_STARTER,
  SUBSCRIPTION_ACCOUNT_PODCAST_BOT,
} from "./state"
import { config as appConfig, config } from "/app.config"

export const accountSubscriptions = (state) => {
  return state.accountSubscriptions
}

export const hasAccountSubscriptions = (state, getters, rootState, rootGetters) => {
  const { isPrime, isStarter, isAdsFree, isPremier, isCustomStations } = getters
  const isPortalAdmin = rootGetters["Profile/isPortalAdmin"]
  const { isZeno, isAiir_Nistar } = config

  if (isPrime || isStarter || isAdsFree || isPremier || isCustomStations) {
    return isPrime || isStarter || isAdsFree || isPremier || isCustomStations
  }

  if (isPortalAdmin || (!isZeno && !isAiir_Nistar)) {
    return true
  }

  return state.accountSubscriptions && state.accountSubscriptions.length > 0
}

const SUBSCRIPTION_STATUS_ACTIVE = ["trialing", "active", "past_due"]

export const hasAccountActiveSubscriptions = (state) => {
  const activeSubscriptions = state.accountSubscriptions?.filter(
    (subscription) => SUBSCRIPTION_STATUS_ACTIVE.indexOf(subscription.status) >= 0
  )
  return activeSubscriptions?.length > 0
}

export const accountActiveSubscriptionsPeriod = (state) => {
  const activeSubscriptions = state.accountSubscriptions?.filter(
    (subscription) => SUBSCRIPTION_STATUS_ACTIVE.indexOf(subscription.status) >= 0
  )

  if (activeSubscriptions?.length) {
    const activeItem = activeSubscriptions[0]?.items?.find((item) => {
      return (
        item.price?.active &&
        (item.price.product.id === SUBSCRIPTION_ACCOUNT_STARTER ||
          item.price.product.id === SUBSCRIPTION_ACCOUNT_PRIME ||
          item.price.product.id === SUBSCRIPTION_ACCOUNT_PREMIER ||
          item.price.product.id === SUBSCRIPTION_ACCOUNT_CUSTOM_STATIONS ||
          item.price.product.id === SUBSCRIPTION_ACCOUNT_PRIME_ADS_FREE)
      )
    })

    return activeItem?.price?.recurring?.interval
  }
}

export const getSubscription = (state) => (priceId) => {
  if (!state.accountSubscriptions || !state.accountSubscriptions.length) {
    return false
  }

  return state.accountSubscriptions.find((subscription) => {
    return subscription.items.find((item) => {
      return item.price.id === priceId
    })
  })
}

export const hasSubscriptionToProduct = (state) => (productId) => {
  if (!productId || !state.accountSubscriptions || !state.accountSubscriptions.length) {
    return false
  }

  return state.accountSubscriptions.find((subscription) =>
    subscription.items.find((item) => item.price.product.id === productId)
  )
}

export const isPrime = (state, getters) => {
  return getters.hasSubscriptionToProduct(SUBSCRIPTION_ACCOUNT_PRIME)
}

export const isStarter = (state, getters) => {
  return getters.hasSubscriptionToProduct(SUBSCRIPTION_ACCOUNT_STARTER)
}

export const isAdsFree = (state, getters) => {
  return getters.hasSubscriptionToProduct(SUBSCRIPTION_ACCOUNT_PRIME_ADS_FREE)
}

export const isPremier = (state, getters) => {
  return getters.hasSubscriptionToProduct(SUBSCRIPTION_ACCOUNT_PREMIER)
}

export const isCustomStations = (state, getters) => {
  return getters.hasSubscriptionToProduct(SUBSCRIPTION_ACCOUNT_CUSTOM_STATIONS)
}

export const isPodcastBot = (state, getters) => {
  if (!config.isZeno) return false
  return getters.hasSubscriptionToProduct(SUBSCRIPTION_ACCOUNT_PODCAST_BOT)
}

export const plans = (state) => {
  return state.plans
}

export const accountPlans = (state) => {
  return state.accountPlans
}

export const currentPlanName = (state, getters) => {
  let planName = null
  let plan = null

  if (getters.isStarter) {
    plan = getters.isStarter
    if (appConfig.isAiir_Nistar) {
      planName = "Streaming 1"
    } else {
      planName = "Starter"
    }
  } else if (getters.isPrime || getters.isAdsFree) {
    plan = getters.isPrime || getters.isAdsFree
    if (appConfig.isAiir_Nistar) {
      planName = "Streaming 2"
    } else {
      planName = "Prime"
    }
  } else if (getters.isPremier) {
    plan = getters.isPremier
    if (appConfig.isAiir_Nistar) {
      planName = "Streaming 3"
    } else {
      planName = "Premier"
    }
  } else if (getters.isCustomStations) {
    plan = getters.isCustomStations
    if (appConfig.isAiir_Nistar) {
      planName = "Streaming"
    } else {
      planName = "Custom Plan"
    }
  }

  if (plan) {
    if (plan.status === "trialing") {
      planName = "Trial"
    }

    if (plan.legacySubscription) {
      planName += " (Legacy)"
    }
  }

  return planName
}

export const accountMainPlan = (state, getters) => {
  const { isStarter, isPrime, isAdsFree, isPremier, isCustomStations } = getters
  return isCustomStations || isPremier || isPrime || isAdsFree || isStarter
}

export const isTrialPlan = (state, getters) => {
  const { accountMainPlan } = getters
  return accountMainPlan && accountMainPlan.status === "trialing"
}
